import { useNavigate } from "react-router-dom";

const OnboardingSalesOverview = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/boss/onboarding/preorder-shortcut");
  };

  return (
    <div className="w-full h-[100dvh] overflow-y-auto max-w-[480px] mx-auto bg-white">
      <div className="flex flex-col p-4 w-full space-y-6">
        <div className="mt-2">
          <h1 className="text-3xl font-semibold text-gray-800">
            사장님, 반갑습니다! 😊
          </h1>
        </div>

        <div className="text-4xl font-semibold text-gray-800 break-keep">
          <span className="text-primary font-bold">두 가지 판매방식</span>을
          알려드릴게요!
        </div>

        <div className="flex flex-col justify-between gap-4 rounded-2xl p-4 ">
          <div className="flex-1 flex flex-col items-center p-6 text-3xl font-bold text-green-500 text-center break-keep bg-green-100 rounded-2xl border-2 border-green-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 mb-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            예약 판매 (랜덤)
          </div>
          <div className="flex-1 flex flex-col items-center p-6 text-3xl font-bold text-blue-500 text-center break-keep bg-blue-100 rounded-2xl border-2 border-blue-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 mb-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <p>실시간</p> <p>알림 판매</p>
          </div>
        </div>

        <button
          onClick={handleClick}
          className=" max-w-[480px] mx-auto w-full py-3.5 bg-primary text-white font-semibold rounded-2xl transition duration-150 active:brightness-90 pointer-events-auto"
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default OnboardingSalesOverview;
